import React from 'react';
// import Button from './Button';
import SpeakerCard from './SpeakerCard';
import member1 from "../assets/images/Dr_Bindey_Kumar.jpg";
import member2 from "../assets/images/TD_Yadav.jpg";
import member3 from "../assets/images/Sujoy_Pal.jpg";
import member4 from "../assets/images/Puneet_Dhar.jpeg";
import member5 from "../assets/images/Subhash_Gupta.jpg";
import member6 from "../assets/images/Saket_Kumar.jpg";
import member7 from "../assets/images/manish_mandal.png";
import member8 from "../assets/images/sanjay_kumar.png";
import member9 from "../assets/images/amarjeet.png";
import member10 from "../assets/images/rakesh_k_singh.png";


const organizingCommittee = [
  { name: 'Prof. (Dr.) Bindey Kumar', specialty: 'Chief Patron, Director, IGIMS, Patna', imageSrc: member1, },
  { name: 'Dr. Manish Mandal', specialty: 'Organising Chairman', imageSrc: member7, },
  { name: 'Dr. Sanjay Kumar', specialty: 'Organising Secretary', imageSrc: member8, },
  { name: 'Dr. TD Yadav', specialty: 'President', imageSrc: member2, },
  { name: 'Dr. Sujoy Pal', specialty: 'Secretary', imageSrc: member3, },
  { name: 'Dr. Saket Kumar', specialty: 'Joint Secretary', imageSrc: member6, },
  { name: 'Dr. Rakesh Kumar Singh', specialty: 'Joint Secretary', imageSrc: member10, },
  { name: 'Dr. Puneet Dhar', specialty: 'President Elect', imageSrc: member4, },
  { name: 'Dr. Subhash Gupta', specialty: 'Immediate Past President', imageSrc: member5, },
  { name: 'Dr. Amarjeet kumar Raj', specialty: 'Treasurer', imageSrc: member9, },
];

function SpeakersSection() {
  return (
    <section id="speakers" className="section speakers-section">
      <div className="container">
        <h2 className="speakers-title">Organizing Committee</h2>
        <p className="speakers-subtitle">
          The team behind IASG Mid-Term Conference 2026.
        </p>
        <div className="speakers-grid">
          {organizingCommittee.map((member) => (
            <SpeakerCard
              key={member.name}
              name={member.name}
              specialty={member.specialty}
              imageSrc={member.imageSrc}
            />
          ))}
        </div>
        {/* <div className="speakers-cta"> 
          <Button variant="secondary" href="#speakers" iconRight="ri-arrow-right-line">
            View All
          </Button>
        </div>*/}
      </div>
    </section>
  );
}

export default SpeakersSection;
